module.exports = __webpack_public_path__ + "static/media/quinco_mental1.0108e278.jpg";